module.exports = "/fonts/Inter_latin.woff2";